// import { useSelector } from 'react-redux';
import MainNavbar from '../../../components/Navbar';
import { Button, Row, Col, Navbar, Modal } from 'react-bootstrap';
import React, { useEffect, useState } from 'react';
import { batchUpdateOwnerMutation, getDepartments, getUsers, searchOwners } from './api';
import { useMutation, useQuery } from '@apollo/client';
import { GridBody } from './components/GridBody';
import { UserList } from '../EditOwner/components/UserList';
import { stripTypenames } from '../../../utils/index';
import { Loader } from '../../../components/Loader';
// import { useHistory } from 'react-router-dom';

export const OwnersPage = (props: any) => {
  const [ownersArray, updateOwnersArray] = useState([]);
  const [showEditModal, setShowEditModal] = useState(false);
  const [userInput, setUserInput] = useState('');
  // const [userInputSearch, setUserInputSearch] = useState('');
  const [searchString, setSearchString] = useState<string>('');
  const [newApplicationUser, setNewApplicationuser] = useState<any>({ name: '' });
  // const history = useHistory();
  var { loading, error, data } = useQuery(searchOwners, { variables: { input: userInput } });
  const deptQuery = useQuery(getDepartments);
  const userQuery = useQuery(getUsers);
  const [updateOwners] = useMutation(batchUpdateOwnerMutation);
 
  // useEffect(() => {
  //   setSearchString(newApplicationUser.name);
  // }, [newApplicationUser]);

  // useEffect(() => {}, [data]);


  if (error || deptQuery.error || userQuery.error) {
    return (
      <>
        <MainNavbar />
        {error && <h4>{error}</h4>}
        {deptQuery.error && <h4>{deptQuery.error}</h4>}
        {userQuery.error && <h4>{userQuery.error}</h4>}
      </>
    );
  }

  if (loading || deptQuery.loading || userQuery.loading) {
    return (
      <>
        <MainNavbar />
        <Loader />
      </>
    );
  }

  if (data && deptQuery.data && userQuery.data) {
    return (
      <>
        <MainNavbar/>
        <div className='m-5'>
          <Row>
            <Col
              style={{
                textAlign: 'center',
              }}>
              <h3>Owners</h3>
            </Col>
          </Row>
          <Row>
            <Col>
              <GridBody data={data.searchOwnerByName} depts={deptQuery.data.readAllDepartments} users={userQuery.data.readUsers}/>
            </Col>
          </Row>
        </div>
      </>
    )
  }

  return null;

  // if (data == undefined) {
  //   console.log('data is undefined');
  //   data = {
  //     searchOwnerByName: [],
  //   };
  // }

  const depts = deptQuery.data.readAllDepartments;

  const appendEditArray = (ownersObj) => {
    ownersArray.push(ownersObj);
    updateOwnersArray(ownersArray);
  };

  const spliceEditArray = (ownersObj) => {
    const index = ownersArray.indexOf(ownersObj);
    if (index > -1) {
      ownersArray.splice(index, 1);
    }
    updateOwnersArray(ownersArray);
  };

  const handleClose = () => setShowEditModal(false);
  const handleShow = () => setShowEditModal(true);

  const validate = () => {
    if (newApplicationUser.id === undefined) {
      return false;
    }
    return true;
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();

    if (ownersArray.length > 0) {
      if (validate()) {
        var tempArr = [];
        ownersArray.forEach((element) => {
          element.userId = Number(newApplicationUser.id);
          element.userName = newApplicationUser.name;
          tempArr.push(stripTypenames(element));
        });

        updateOwners({ variables: { owners: tempArr } })
          // .then(() => history.push('/Admin/owners/updated'))
          .catch((err) => console.log('Error: /frontend/src/pages/Admin/Owners//handleSubmit', err));
        setShowEditModal(false);
        window.location.reload();
      }
    }
  };

  const footerBar = () => {
    return (
      <Navbar fixed='bottom' className='footer' bg='dark'>
        <div className='container-fluid'>
          <div className='col-sm-6 text-right'>
            <input
              type='search'
              onChange={(e) => {
                setUserInput(e.target.value);
              }}
              // onKeyPress={(e) => {
              //   if (e.key === 'Enter') {
              //     setUserInputSearch(userInput);
              //   }
              // }}
              className='col-sm-4'
              placeholder='Search by user name'
              value={userInput}
            />
          </div>
          <div className='col-sm-2 text-right'>
            <Button onClick={handleShow}>Edit Selection</Button>
          </div>
        </div>
      </Navbar>
    );
  };

  const editModal = () => {
    return (
      <Modal show={showEditModal} onHide={handleClose} centered scrollable>
        <Modal.Header closeButton>
          <Modal.Title>Edit Owner</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='container-fluid'>
            <label style={{ display: 'flex', justifyContent: 'center' }}>Search users to assign new owner:</label>
            <input
              value={searchString}
              type='text'
              className='form-control mb-3'
              style={{ display: 'flex', justifyContent: 'center' }}
              onChange={(e) => setSearchString(e.target.value)}
            />

            {<UserList searchString={searchString} setNewApplicationUser={setNewApplicationuser} />}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='primary' onClick={handleSubmit}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  return (
    <>
      <MainNavbar />
      <div className='m-5'>
        <Row>
          <Col
            style={{
              textAlign: 'center',
            }}>
            <h3>Owners</h3>
          </Col>
        </Row>
        <Row>
          <Col>
            <GridBody data={data.searchOwnerByName} depts={depts} add={appendEditArray} remove={spliceEditArray} />
          </Col>
        </Row>
      </div>
      {/* {footerBar()}
      {editModal()} */}
    </>
  );
};
